"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailTemplatePreview = exports.default = exports.checkUnsubscribeLink = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _header = _interopRequireDefault(require("../../header"));

var _Message = require("../../ui-components/Message");

var _RawEmailEditor = require("../../raw-email-editor/RawEmailEditor");

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _dropdown = _interopRequireWildcard(require("../../../preact-components/design-system-components/dropdown"));

var _logger = require("@insided/shared/services/logger");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var variables = [{
  name: '{content}',
  description: 'Content'
}, {
  name: '{unsubscribeUrl}',
  description: 'Unsubscribe URL'
}];

var emailTemplatePreview = function emailTemplatePreview(content) {
  var dummyEmailCampaign = 'Content of your email campaign comes here. You can configure the content while creating the email campaign.';
  return content.replace('{content}', dummyEmailCampaign);
};

exports.emailTemplatePreview = emailTemplatePreview;

var checkUnsubscribeLink = function checkUnsubscribeLink(content) {
  var isUnsubscribeLinkValid = false;
  var fakeBody = document.createElement('div');
  fakeBody.innerHTML = content.slice(content.indexOf('<body'), content.indexOf('</body'));
  var isUnsubscribeLinkExist = !!fakeBody.querySelector('a[href="{unsubscribeUrl}"]');

  if (isUnsubscribeLinkExist) {
    var contentStartWithUnsubscribeUrl = content.slice(content.indexOf('{unsubscribeUrl}'));
    var contentStartWithUnsubscribeUrlClosingTag = contentStartWithUnsubscribeUrl.slice(contentStartWithUnsubscribeUrl.indexOf('<'));
    isUnsubscribeLinkValid = contentStartWithUnsubscribeUrlClosingTag.indexOf('</a>') === 0;
  }

  return isUnsubscribeLinkExist && isUnsubscribeLinkValid;
};

exports.checkUnsubscribeLink = checkUnsubscribeLink;

var EmailTemplateEdit = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailTemplateEdit, _Component);

  var _super = _createSuper(EmailTemplateEdit);

  function EmailTemplateEdit() {
    var _this;

    (0, _classCallCheck2.default)(this, EmailTemplateEdit);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cursor", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "codeMirror", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      emailTemplateId: _this.props.emailTemplateId || null,
      content: '',
      alertMessage: '',
      alertMessageType: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentChange", function (html) {
      _this.setState({
        content: html
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveChanges", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, emailTemplateId, content, isUnsubscribeLinkValid;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, emailTemplateId = _this$state.emailTemplateId, content = _this$state.content;
              isUnsubscribeLinkValid = checkUnsubscribeLink(content);

              if (!(!content.includes('{content}') || !content.includes('{unsubscribeUrl}') || !isUnsubscribeLinkValid)) {
                _context.next = 5;
                break;
              }

              _this.setState({
                alertMessageType: 'error',
                alertMessage: 'Please include {content} and {unsubscribeUrl} tags in your template, and the {unsubscribeUrl} is within an anchor and within the body tags.'
              });

              return _context.abrupt("return");

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return _axios.default.post('/emailTemplate/save', {
                emailTemplateId: emailTemplateId,
                content: content
              });

            case 8:
              _this.setState({
                alertMessageType: 'success',
                alertMessage: 'All changes saved successfully!'
              });

              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);

              _logger.logger.error(_context.t0, {
                component: 'EmailTemplateEdit',
                action: 'onSaveChanges'
              });

              _this.setState({
                alertMessageType: 'error',
                alertMessage: ''
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 11]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function () {
      var _this$codeMirror;

      _this.cursor = (_this$codeMirror = _this.codeMirror) === null || _this$codeMirror === void 0 ? void 0 : _this$codeMirror.getCursor();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "insertVariable", function (varName) {
      if (!_this.cursor || !_this.codeMirror) return;

      _this.codeMirror.replaceRange(varName, _this.cursor);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCodeMirrorRef", function (codeMirror) {
      _this.codeMirror = codeMirror;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideAlertMessage", function () {
      _this.setState({
        alertMessageType: null,
        alertMessage: ''
      });
    });
    return _this;
  }

  (0, _createClass2.default)(EmailTemplateEdit, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var emailTemplateId, response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                emailTemplateId = this.state.emailTemplateId;
                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.get("/emailTemplate/find/".concat(emailTemplateId));

              case 4:
                response = _context2.sent;
                this.setState({
                  content: response.data.Content
                });
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                _logger.logger.error(_context2.t0, {
                  component: 'EmailTemplateEdit',
                  action: 'componentDidMount'
                });

                this.setState({
                  alertMessageType: 'error',
                  alertMessage: 'Something went wrong, please try again later.'
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          content = _this$state2.content,
          alertMessageType = _this$state2.alertMessageType,
          alertMessage = _this$state2.alertMessage;
      return (0, _preact.h)("div", {
        className: "email-template",
        "data-bounded-context": "Campaigns",
        "data-entity": "email-template"
      }, (0, _preact.h)(_header.default, {
        title: "Customise theme",
        hasBreadcrumb: true,
        breadcrumbText: "Email Campaigns",
        breadcrumbLink: "/email/email-campaigns",
        cancelCallback: function cancelCallback() {
          return window.location.assign('/email/email-campaigns');
        },
        saveCallback: this.onSaveChanges
      }), alertMessageType && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: alertMessageType,
        onDismiss: this.hideAlertMessage,
        timer: 3000
      }, alertMessage), (0, _preact.h)(_Message.Message, {
        text: (0, _preact.h)("div", null, 'Please include these tags in the template: The {content} tag and the {unsubscribeUrl} tag. Ensure that the {unsubscribeUrl} is within the <body> and the <a href=””> tags, and that it is not hidden. ', (0, _preact.h)("a", {
          target: "_blank",
          rel: "noreferrer",
          href: "https://communities.gainsight.com/email-campaigns-66/customize-the-theme-for-email-campaigns-22246"
        }, "Read more")),
        fullWidth: true
      }), (0, _preact.h)("div", {
        className: "email-template-editor-contianer"
      }, (0, _preact.h)(_dropdown.default, {
        size: "S",
        align: "right",
        popupName: "insert-email-variables-list",
        trigger: (0, _preact.h)("div", {
          className: "insert-email-variables-trigger"
        }, "Insert variables"),
        closeOnDropdownClick: true
      }, variables.map(function (item) {
        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: item.name,
          onClick: function onClick() {
            _this2.insertVariable(item.name);
          }
        }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: "email-variable"
        }, item.name), (0, _preact.h)("div", {
          className: "email-variable-description"
        }, item.description)));
      })), (0, _preact.h)(_RawEmailEditor.RawEmailEditor, {
        content: content,
        onContentChange: this.onContentChange,
        setCodeMirrorRef: this.setCodeMirrorRef,
        onBlur: this.onBlur,
        contentForPreview: emailTemplatePreview(content)
      })));
    }
  }]);
  return EmailTemplateEdit;
}(_preact.Component);

var _default = EmailTemplateEdit;
exports.default = _default;